module.exports = __webpack_public_path__ + "img/icon07.1fb1d736.png";